import { useCallback } from 'react'
import type { JSX } from 'react'
import { Link } from 'react-router-dom'

import {
  Flex,
  IconButton,
  Heading,
  SettingsIcon,
  PlusIcon,
} from '@buffer-mono/popcorn'

import { useHasOrganizationAction } from '~publish/contexts/AccountContext'
import { settingsSavedRepliesRoute } from '~publish/legacy/routes'

import styles from './SavedRepliesPopover.module.css'

export const SavedReplyHeader = ({
  setOpenForm,
  hasReachedLimit,
  hasSavedReplies,
  setOpenPaywall,
}: {
  setOpenForm: (open: boolean) => void
  hasReachedLimit: boolean
  hasSavedReplies: boolean
  setOpenPaywall: (open: boolean) => void
}): JSX.Element => {
  const canManageSavedReplies = useHasOrganizationAction('manageSavedReplies')

  const handleAddNewSavedReply = useCallback(() => {
    if (hasReachedLimit) {
      setOpenPaywall(true)
    } else {
      setOpenForm(true)
    }
  }, [hasReachedLimit, setOpenPaywall, setOpenForm])

  return (
    <Flex direction="row" justify="between" align="center">
      <Heading size="sm" className={styles.header}>
        Saved replies
      </Heading>

      {hasSavedReplies && (
        <Flex direction="row" gap="xs">
          <IconButton
            as={Link}
            to={settingsSavedRepliesRoute.route}
            variant="tertiary"
            size="small"
            label="Settings"
            tooltip="Settings"
          >
            <SettingsIcon />
          </IconButton>

          {canManageSavedReplies && (
            <IconButton
              variant="secondary"
              size="small"
              label="Add new saved reply"
              onClick={handleAddNewSavedReply}
              tooltip="Add new saved reply"
            >
              <PlusIcon />
            </IconButton>
          )}
        </Flex>
      )}
    </Flex>
  )
}
